import { Tooltip } from '@mui/material';
import React from 'react';
import Input from 'shared/component/inputFields';
import TextArea from 'shared/component/textArea';
import { useCreateOrder } from "customer/orders/create-order/create-order.service";
import { localize } from "shared/helpers/utils";

const FromDetails = (props) => {
  const {orderData,pickPoints,setOrderData,pickPointForm} = useCreateOrder();
  const {register,handleSubmit} = pickPointForm
  const address = pickPoints?.data?.find(a => a.id === orderData?.pickPoint);


  const next = data => {
    setOrderData(d => ({...d,...data}));
    props.nextStep();
  }

    return (
        <form onSubmit={handleSubmit(next)} className='myorder fromDetails'>
            <div className='container'>
            <div className='steps'>
                    <Tooltip title="NEW ORDER" arrow>
                        <span className='indicator done'></span>
                    </Tooltip>
                    <Tooltip title="SHIPPING DETAILS" arrow>
                        <span className='indicator done'></span>
                    </Tooltip>
                    <Tooltip title="FROM DETAILS" arrow>
                        <span className='indicator active'></span>
                    </Tooltip>
                    <Tooltip title="TO DETAILS" arrow>
                        <span className='indicator'></span>
                    </Tooltip>
                    <Tooltip title="DESTINATIONS" arrow>
                        <span className='indicator'></span>
                    </Tooltip>
                    <Tooltip title="SUMMARY" arrow>
                        <span className='indicator'></span>
                    </Tooltip>
                    <Tooltip title="PENDING" arrow>
                        <span className='indicator'></span>
                    </Tooltip>
                </div>

                <div className='box-order'>
                    <div className='order-header'>
                        <h1 className='title'>Pickup Point</h1>
                        <hr className='hr' />
                    </div>

                    <div className='row'>
                        <div className='col-md-6'>
                            <Input type="text" label="Pickup Point:"  readonly value={localize(address?.addressName)} />
                        </div>
                        <div className='col-md-6'>
                        <Input type="text" label="Location:" location {...register('location')}  />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-6'>
                            <Input type="text" label="Contact Person:" {...register('contactPerson')}/>
                        </div>
                        <div className='col-md-6'>
                            <Input type="phone" label="Phone:" {...register('phone')} />
                        </div>
                        <div className='col-md-12'>
                        <TextArea  label="Full Address:" {...register('fullAddress')} />
                        </div>
                        <div className='col-md-12'>
                            <TextArea label="Goods Discerption:" {...register('goods')} />
                        </div>
                    </div>
                </div>

            </div>
          <div className='action'>
            <div className='container'>
              <button type='button' className='btn-border-blue' onClick={props.previousStep}>Back</button>
              <button type='submit' className='btn-blue'>Next</button>
            </div>
          </div>
        </form>
    )
}

export default FromDetails